module.exports = __webpack_public_path__ + "img/default-work.06601a17.png";